<div  
  class="ip-title-mobile"
  [ngClass]="{
    'ip-title-mobile__remove-space-bottom_mb': removeMgBottomMobile,
    'ip-title-mobile__remove-space-bottom_desktop': removeMgBottomDesktop,
    'ip-title-mobile__no-background': noBackground
  }">
  <div class="ip-title-mobile__title">
    <mat-icon class="ip-title-mobile__title-back-icon" *ngIf="back" (click)="goBack()">arrow_back</mat-icon>
    {{ title }}
  </div>
  <button
    class="ip-title-mobile__btn"
    *ngIf="btn === 'create'"
    (click)="onClickButton($event)">
    <mat-icon class="ip-title-mobile__btn-icon">add</mat-icon>
    <span *ngIf="mobile">{{ "IP.COMMON.BUTTON-CREATE" | translate }}</span>
    <span *ngIf="!mobile">{{ btnText ?? ("IP.COMMON.BUTTON-CREATE" | translate) }}</span>
  </button>
  <button
    class="ip-title-mobile__btn"
    *ngIf="btn === 'filter' && mobile"
    (click)="onClickButton($event)">
    <mat-icon class="ip-title-mobile__btn-icon">search</mat-icon>
    <span>{{ "IP.FILTERS_MODAL.FILTER" | translate }}</span>
  </button>
  <img class="ip-title-mobile__btn-settings" src="assets/icons/settings.svg" alt="" (click)="onClickButton($event)" *ngIf="btn === 'settings'">
  <img
    *ngIf="withAvatar && avatarUrl"
    [src]="avatarUrl"
    class="ip-title-mobile-avatar"
    (click)="onClickAvatar($event)"
  />
  <app-ip-default-avatar *ngIf="withAvatar && !avatarUrl" (click)="onClickAvatar($event)" class="ip-title-mobile-avatar"></app-ip-default-avatar>
</div>
<div class="ip-title-mobile-sm" *ngIf="mobile"></div>
